import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

function ProgramType(props) {
  const { type } = props;
  let l = type;
  if (type === 'Win Loss') {
    l = 'wl';
  } else if (type === 'Customer Experience') {
    l = 'ce';
  } else if (type === 'Voice of the Buyer') {
    l = 'vb';
  }
  return (<span className={`${styles.type} ${styles[l]}`}>{l}</span>);
}

ProgramType.propTypes = {
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
ProgramType.defaultProps = {
};
export default ProgramType;
